import { Box, Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Link, useNavigate } from "react-router-dom"
import SubmitButton from "../UI/SubmitButton"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { getBranchAction } from "../asyncActions/branchActions"
import { allWarehouseListAction } from "../asyncActions/warhouseActions"


function BranchesPage() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(allWarehouseListAction())
    }, [])

    const {
        branchList,
        dataLoad
    } = useSelector(store => store.warhouse)

    const editHandle = (id) => {
        navigate(`/branches/edit/${id}`)
    }

    const rows = branchList.slice().sort((a) => a.isArchived ? 1 : -1)


    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '25px'
        }}>
            <Typography variant="h4">Branches managment</Typography>

            <Box>
                <Link to='/branches/create'>
                    <SubmitButton>Add new branch</SubmitButton>
                </Link>
            </Box>

            {dataLoad ? (
                <CircularProgress />
            ) : (
                <Box>
                    <TableContainer sx={{
                        padding: '20px'
                    }}
                        component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Branch</TableCell>
                                    <TableCell>Kitchen</TableCell>
                                    <TableCell>Archived</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((branch) => (
                                    <TableRow key={branch.id}>
                                        <TableCell>{branch.id}</TableCell>
                                        <TableCell>{branch.name}</TableCell>
                                        <TableCell>{branch.isKitchen ? "Yes" : "No"}</TableCell>
                                        <TableCell>{branch.isArchived ? "Yes" : "No"}</TableCell>
                                        <TableCell>
                                            <SubmitButton onClick={() => editHandle(branch.id)}>Edit</SubmitButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}


        </Box>
    )
}


export default BranchesPage